import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { getDomainDetails } from '../../../../../../MastersDataCollection/curriculumLibraries/components/domain/actions/domainActions';
import { saveMasterDomainById } from './actions/skillAquisitionDomainActions';
import { renderTextField } from '../../../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';

import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';


export const validate = (values) => {
    const errors = {};
    if (!values.domainName) {
        errors.domainName = 'Please enter domain name';
    }
    return errors;
};


class SkillAquisitionEditDomainModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            skillAcquisitionDomainId: props.skillAcquisitionDomainId
        };
    }

    componentWillMount() {
        if (this.props.domainId) {
            this.props.getDomainDetails(this.props.domainId);
        }
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {
            this.props.clearFieldErrorArray();
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };

    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    onSubmitHandler(formProps) {

        if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
            return null;
        }
        let postData = {
            "id": this.props.initialValues.id,
            "libraryId": this.props.initialValues.libraryId,
            "domainName": formProps.domainName,
            "isActive": this.props.initialValues.isActive,
            "totalRecords": 0,
            "patientId" : this.props.patientId,
        }
        this.props.clearFieldErrorArray();
        this.props.saveMasterDomainById(postData, this.props.patientId);
        this.setState({ open: false });
        this.props.closeDialog();
    }

    checkFieldDataExistence = (input, value, labelName) => {
        if (value.length > 0) {
            let postData = {
                'labelName': labelName,
                'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
                'value': value,
                'colmnName': input.target.name.toUpperCase(),
                'id': this.state.skillAcquisitionDomainId || 0,
            };
            this.props.checkFieldExistence(postData);
        }
    };

    handleNewRequest = (input, selectedRecord) => {
        input.onChange(selectedRecord.value);
    };

    render() {
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
            <SubmitButtonModalDisabled label="Loading" /> :
            <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
        ];
        return <Dialog className="custom_modal" title="Edit Domain" modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
            {this.renderLoading()}
            <div className="row">
                <div className="col-sm-12">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                        <div className="row">
                            <div className="col-sm-12 require mt-30">
                                <Field autoFocus={true}
                                    name="domainName"
                                    label="Edit Domain"
                                    type="text"
                                    maxLength="250"
                                    component={renderTextField} />
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-sm-3">
                                <Field className="mt20 mb0" name="isActive" label="Is Active" component={renderCheckBox} />
                            </div>
                        </div> */}
                    </form>
                </div>
            </div>
        </Dialog>;
    }
}

SkillAquisitionEditDomainModal = reduxForm({
    form: 'SkillAquisitionEditDomainForm',
    validate,
    enableReinitialize: true,
})(SkillAquisitionEditDomainModal);


function mapStateToProps(state, ownProps) {
    let initialValueData = {
        isActive: true,
    };

    if (ownProps.domainId && state.domain.domainListDetails) {
        initialValueData = state.domain.domainListDetails.data || null;
    }

    return {
        loading: state.domain.loading,
        fieldError: state.appConfig.fieldError,
        fieldErrorLoading: state.appConfig.fieldErrorLoading,
        initialValues: initialValueData,
    }
}

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getDomainDetails, saveMasterDomainById })(SkillAquisitionEditDomainModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/EditDomainModal.js